import React from 'react';
import { Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import {
	MobileDataList,
	MobileListCard,
	MobileListCardHeader,
} from '../../../Components/MobileDataList';

const displayName = (user) => {
	const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
	return fullName || user.username;
};

const UserListCard = ({ user, onEdit, onRemove }) => {
	const subtitle = user.email || user.username;
	const usernameHint = user.username && user.email ? `@${user.username}` : null;

	return (
		<MobileListCard>
			<Stack spacing={1.5}>
				<MobileListCardHeader
					title={displayName(user)}
					subtitle={
						subtitle ? (
							<>
								{subtitle}
								{usernameHint ? (
									<Typography
										component="span"
										variant="caption"
										color="text.secondary"
										sx={{ display: 'block', mt: 0.25 }}
									>
										{usernameHint}
									</Typography>
								) : null}
							</>
						) : null
					}
					endAdornment={
						<Chip
							label={user.role}
							size="small"
							color={user.role === 'Manager' ? 'primary' : 'default'}
							variant={user.role === 'Manager' ? 'filled' : 'outlined'}
							sx={{ flexShrink: 0 }}
						/>
					}
				/>

				{user.hourly_cost != null && user.hourly_cost !== '' ? (
					<Typography variant="body2" color="text.secondary">
						Hourly cost:{' '}
						{new Intl.NumberFormat('en-US', {
							style: 'currency',
							currency: 'USD',
						}).format(Number(user.hourly_cost))}
					</Typography>
				) : null}

				<Stack direction="row" spacing={0.5} justifyContent="flex-end">
					<Tooltip title="Edit">
						<IconButton size="small" onClick={() => onEdit(user)}>
							<EditIcon fontSize="small" />
						</IconButton>
					</Tooltip>
					<Tooltip title="Remove">
						<IconButton
							size="small"
							color="error"
							onClick={() => onRemove(user)}
						>
							<DeleteOutlineIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Stack>
			</Stack>
		</MobileListCard>
	);
};

const UsersMobileList = ({ users, isLoading, onEdit, onRemove }) => (
	<MobileDataList
		items={users}
		isLoading={isLoading}
		getKey={(user) => user.id}
		emptyTitle="No team members yet"
		emptyDescription="Add a user to give your crew access to jobs and customers."
		renderItem={(user) => (
			<UserListCard user={user} onEdit={onEdit} onRemove={onRemove} />
		)}
	/>
);

export default UsersMobileList;
